export enum ShippingMethodsEnum {
    FREE,
    COURIER_PICK_UP,
    SHIPPING_MY_OWN,
}

export const shippingMethodNames: { [id: number]: string } = {
    [ShippingMethodsEnum.FREE]: 'orders.shippingMethod.free',
    [ShippingMethodsEnum.COURIER_PICK_UP]: 'orders.shippingMethod.courierPickup',
    [ShippingMethodsEnum.SHIPPING_MY_OWN]: 'orders.shippingMethod.shippingMyOwn',
};
